var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "parent_div", attrs: { id: "ms_header_downside" } },
    [
      _c("dd-header"),
      _vm._v(" "),
      _c("div", { staticClass: "wrapper" }, [
        _c(
          "div",
          { staticClass: "main_content" },
          [
            _c("dd-menu", { ref: "menuRef" }),
            _vm._v(" "),
            _c(
              "div",
              [
                _c("dd-sitemap", {
                  attrs: {
                    pageKey: _vm.pageKey,
                    pageList: _vm.pageList,
                    mapStyle: "topic_path"
                  }
                }),
                _vm._v(" "),
                _vm._m(0),
                _vm._v(" "),
                _vm._m(1),
                _vm._v(" "),
                _c("section", [
                  _c("h2", [
                    _vm._v(
                      "1ミリ単位のサイズオーダー商品を、お客様にご提案いただけます。"
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "description_with_img" }, [
                    _c("img", {
                      attrs: {
                        src: _vm.getImage("top/corpprice/01_design.webp")
                      }
                    }),
                    _vm._v(" "),
                    _vm._m(2)
                  ])
                ]),
                _vm._v(" "),
                _c("section", [
                  _c("h2", [
                    _vm._v(
                      "国内工場とシステム連携、高品質な収納家具をお手頃価格で提供"
                    )
                  ]),
                  _vm._v(" "),
                  _vm._m(3),
                  _vm._v(" "),
                  _c("img", {
                    attrs: {
                      src: _vm.getImage("top/corpprice/02-02_automation.webp")
                    }
                  })
                ]),
                _vm._v(" "),
                _c("section", [
                  _c("h2", [_vm._v("法人会員登録するとこんなに便利！")]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "procedure_with_img member_benefits" },
                    [
                      _c("div", [
                        _c("h3", [_vm._v("① 法人会員限定価格での商品購入")]),
                        _vm._v(" "),
                        _c("img", {
                          attrs: {
                            src: _vm.getImage(
                              "top/corpprice/04-01_special.webp"
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "\n                法人会員様限定の割引価格にて商品をご購入いただけるようになります。\n              "
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c("h3", [
                          _vm._v("② メールマガジンでお得な情報をお届け")
                        ]),
                        _vm._v(" "),
                        _c("img", {
                          attrs: {
                            src: _vm.getImage("top/corpprice/04-03_mail.webp")
                          }
                        }),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "\n                クーポンや新商品、キャンペーンの情報などをいち早くお届けいたします。\n              "
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c("h3", [_vm._v("③ カスタマイズ情報の保存")]),
                        _vm._v(" "),
                        _c("img", {
                          attrs: {
                            src: _vm.getImage("top/corpprice/04-04_save.webp")
                          }
                        }),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "\n                カスタマイズ中の商品情報を保存しておくことができます。\n              "
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c("h3", [
                          _vm._v("④ オーダー家具営業ノウハウのご提供")
                        ]),
                        _vm._v(" "),
                        _c("img", {
                          attrs: {
                            src: _vm.getImage(
                              "top/corpprice/04-06_knowhow.webp"
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "\n                サービスの活用方法について、施工事例などを通してご案内いたします。\n              "
                          )
                        ])
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "detail_btn btn_pos_center",
                      on: {
                        click: function($event) {
                          _vm.route("DcOrderSignIn")
                        }
                      }
                    },
                    [_vm._v("会員登録はこちら 〉〉")]
                  )
                ]),
                _vm._v(" "),
                _c("a", { attrs: { href: "tel:0362761123" } }, [
                  _c("img", { attrs: { src: _vm.getImage("bunner/TEL.webp") } })
                ]),
                _vm._v(" "),
                _c("section", [
                  _c("h2", [_vm._v("ご注文方法は？")]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "mm/style (ミリスタイル) は、たった3ステップで別注収納が注文できます。"
                    )
                  ]),
                  _vm._v(" "),
                  _c("img", {
                    attrs: {
                      src: _vm.getImage("top/payment_guide/00_flow.webp")
                    }
                  }),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "ご注文までの一連の作業が、サイト内で完結するので、必要になったその時に、何時でもご利用していただけます。 また、ご注文いただいた家具は、弊社システムと製造連携している機械化された工場で生産を行いますので、高いサービス品質でありながら低価格・短納期でご提供可能となります。"
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "detail_btn2 btn_pos_center",
                      on: {
                        click: function($event) {
                          _vm.route("DcPaymentGuide")
                        }
                      }
                    },
                    [_vm._v("購入ガイドはこちら 〉〉")]
                  )
                ])
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("dd-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "meinmenu_title" }, [
      _c("div", [_vm._v("はじめてご利用の業者様へ")]),
      _vm._v(" "),
      _c("div", [_vm._v("特別仕切り価格のご案内")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "guide_title_msg" }, [
      _vm._v(
        "\n          mm/styleは、従来の規格サイズの収納家具では解決できない、「お部屋の間取りにピッタリ合わせた収納家具が欲しい」というお客様の要望を叶える収納家具を販売する専門サイトです。"
      ),
      _c("br"),
      _vm._v(
        "\n          トイレや洗濯機上の吊戸棚（フロート収納）、テレビボード、食器棚（カップボード）、壁面収納など、あらゆる住居空間の収納を取り揃えております。"
      ),
      _c("br"),
      _vm._v(" "),
      _c("br"),
      _vm._v(
        "\n          400社を超える業者様にご利用をいただいております。オーダー収納家具のご提供は、安心してmm/styleにお任せください。\n        "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("p", [
        _vm._v(
          "\n                収納家具を1mm単位でサイズオーダーが可能ですので、\n                お客様からの『カウンターテーブル下の収納スペースにピッタリサイズの壁面収納が欲しい！』\n                『部屋の間取りに合わせた食器棚（カップボード）が欲しい』という要望にお応えするために、mm/styleをご活用ください。\n              "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "\n            既製品の収納家具では、本当の意味で住み心地を良くする住居空間の提案を、お客様にすることはできません。しかしながら、\n            「フルオーダーの家具はいいけど、価格が高くて」というお客様が多いことも事実です。"
      ),
      _c("br"),
      _vm._v(
        "\n            mm/styleは単なるプランニングサイトではなく、独自の特許取得済みのシステムにて、工場と直接データ連携がされております。"
      ),
      _c("br"),
      _vm._v(
        "\n            作図作業や見積り積算作業、加工データ作成作業などが全て自動化されているため、通常は人が膨大な時間をかけて行う中間工程がありません。"
      ),
      _c("br"),
      _vm._v(
        "\n            そのために、実績の豊富な国内工場での生産でありながら、お手軽な価格のオーダー家具を提供することが可能となっております。\n          "
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-16f21c4e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16f21c4e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/hakotan/pages/DcSpecialPrice.vue
// module id = null
// module chunks = 